import { render, staticRenderFns } from "./DestinationView.vue?vue&type=template&id=52f6799f&scoped=true&"
import script from "./DestinationView.vue?vue&type=script&lang=ts&"
export * from "./DestinationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f6799f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f6799f')) {
      api.createRecord('52f6799f', component.options)
    } else {
      api.reload('52f6799f', component.options)
    }
    module.hot.accept("./DestinationView.vue?vue&type=template&id=52f6799f&scoped=true&", function () {
      api.rerender('52f6799f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/DestinationView.vue"
export default component.exports